import type { TicketProposal } from '@nxsys/types/models/AiChat';

// Penny embeds a hidden HTML comment in its reply when it proposes a support
// ticket: <!-- TICKET_PROPOSAL: {"subject":"...","description":"..."} -->
// It's invisible when rendered, and lets the UI show the "raise ticket" card
// from the last assistant message (survives reloads, no extra state).
const TICKET_MARKER = /<!--\s*TICKET_PROPOSAL:\s*(\{[\s\S]*?\})\s*-->/;
// Also matches an incomplete marker still streaming in, so it can be hidden.
const TICKET_MARKER_PARTIAL = /<!--\s*TICKET_PROPOSAL:[\s\S]*$/;

export const parseTicketProposal = (content: string): TicketProposal | null => {
  const m = content.match(TICKET_MARKER);
  if (!m) return null;
  try {
    const parsed = JSON.parse(m[1]);
    if (parsed?.subject && parsed?.description) {
      return {
        subject: String(parsed.subject),
        description: String(parsed.description),
        ...(parsed.appendToTicketNumber
          ? { appendToTicketNumber: String(parsed.appendToTicketNumber) }
          : {}),
      };
    }
  } catch {
    // ignore malformed marker
  }
  return null;
};

/** Remove the marker (complete or still-streaming) from text before display. */
export const stripTicketMarker = (content: string): string =>
  content.replace(TICKET_MARKER, '').replace(TICKET_MARKER_PARTIAL, '').trimEnd();
